import { Avatar, Card } from "antd";
import React from "react";

import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

const responsive = {
  superLargeDesktop: {
    // the naming can be any, depends on you.
    breakpoint: { max: 4000, min: 3000 },
    items: 5,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 3,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 2,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
  },
};

const Testimonial = () => {
  return (
    <>
      <div className="max-w-6xl mx-auto my-16  px-5 md:px-5">
        <div className="pb-12 md:pb-20">
          <h3 className="text-base leading-4 tracking-widest uppercase text-lightGrey mb-4">
            Testimonial
          </h3>

          <h1
            className="text-4xl md:text-5xl font-bold leading-tighter mb-0  md:mb-4"
            data-aos="zoom-y-out"
          >
            What They Say About
            <span className="text-green-600 ml-4" data-aos="zoom-y-out">
              Us
            </span>
          </h1>
          <Carousel responsive={responsive} className="mt-12 p-8">
            <Card hoverable className="mr-8">
              <h1 className="text-xl md:text-xl font-bold  mb-4" data-aos="zoom-y-out">
                Best platform
              </h1>

              <p className="font-normal text-base text-border">
                Hire Enumerator is your dedicated partner in the realm of skilled manpower
                solutions, offering a streamlined and expert-driven a effectiveness.
              </p>
              <div className="flex gap-2 items-center mt-6">
                <Avatar size={45}>A</Avatar>
                <div>
                  <h2 className="text-base font-semibold leading-8">Anee Shrestha</h2>
                  <p className="font-normal text-base text-border">Founder & CEO</p>
                </div>
              </div>
            </Card>

            <Card hoverable className="mr-8">
              <h1 className="text-xl md:text-xl font-bold  mb-4" data-aos="zoom-y-out">
                Best platform
              </h1>

              <p className="font-normal text-base text-border">
                Hire Enumerator is your dedicated partner in the realm of skilled manpower
                solutions, offering a streamlined and expert-driven a effectiveness.
              </p>
              <div className="flex gap-2 items-center mt-6">
                <Avatar size={45}>A</Avatar>
                <div>
                  <h2 className="text-base font-semibold leading-8">Anee Shrestha</h2>
                  <p className="font-normal text-base text-border">Founder & CEO</p>
                </div>
              </div>
            </Card>

            <Card hoverable className="mr-8">
              <h1 className="text-xl md:text-xl font-bold  mb-4" data-aos="zoom-y-out">
                Best platform
              </h1>

              <p className="font-normal text-base text-border">
                Hire Enumerator is your dedicated partner in the realm of skilled manpower
                solutions, offering a streamlined and expert-driven a effectiveness.
              </p>
              <div className="flex gap-2 items-center mt-6">
                <Avatar size={45}>A</Avatar>
                <div>
                  <h2 className="text-base font-semibold leading-8">Anee Shrestha</h2>
                  <p className="font-normal text-base text-border">Founder & CEO</p>
                </div>
              </div>
            </Card>

            <Card hoverable className="mr-8">
              <h1 className="text-xl md:text-xl font-bold  mb-4" data-aos="zoom-y-out">
                Best platform
              </h1>

              <p className="font-normal text-base text-border">
                Hire Enumerator is your dedicated partner in the realm of skilled manpower
                solutions, offering a streamlined and expert-driven a effectiveness.
              </p>
              <div className="flex gap-2 items-center mt-6">
                <Avatar size={45}>A</Avatar>
                <div>
                  <h2 className="text-base font-semibold leading-8">Anee Shrestha</h2>
                  <p className="font-normal text-base text-border">Founder & CEO</p>
                </div>
              </div>
            </Card>
          </Carousel>
        </div>
      </div>
    </>
  );
};

export default Testimonial;
